import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { equalisations as rules } from 'further-ui/validations';
import { z } from 'zod';

export type EqualisationFormValues = z.infer<
  typeof rules.UpdateEqualisationActionsFormSchema
>;

type Props = {
  values: EqualisationFormValues;
  children: React.ReactNode;
};

const FormWrapper: React.FC<Props> = ({ children, values }) => {
  const formMethods = useForm<EqualisationFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.UpdateEqualisationSchema),
    values,
    criteriaMode: 'all',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
